import { render, staticRenderFns } from "./user-admin-new.vue?vue&type=template&id=699f9d0a&"
import script from "./user-admin-new.vue?vue&type=script&lang=js&"
export * from "./user-admin-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports